export enum PersonType {
  PhysicalPerson = 1,
  LegalPerson = 2,
}
